import { Skeleton } from 'antd';
import React from 'react';

interface Props {
  isLoading?: boolean;
  children?: JSX.Element | string;
}

export const SellingZoneSkeleton: React.FC<Props> = (props: Props) => {
  const { children, isLoading } = props;

  // const isLoading = true;

  const attrs = {
    wrapper: {
      className: 'my-deals__second-column__sz-row__selling-zone__skeleton',
    },
    header: {
      className:
        'my-deals__second-column__sz-row__selling-zone__skeleton-header',
    },
    body: {
      wrapper: {
        className:
          'my-deals__second-column__sz-row__selling-zone__skeleton__body',
      },
      greyZone: {
        className:
          'my-deals__second-column__sz-row__selling-zone__skeleton__body-grey-zone',
      },
    },
    footer: {
      className:
        'my-deals__second-column__sz-row__selling-zone__skeleton__footer',
    },
    footerTick: { style: { width: '7%' } },

    skeletons: {
      header: {
        loading: isLoading,
        active: true,
        avatar: false,
        paragraph: false,
        title: {
          style: {
            width: 82,
            maxWidth: '100%',
            height: 13,
            borderRadius: 2,
            marginTop: 2,
          },
        },
      },
      sectionHeading: {
        loading: isLoading,
        active: true,
        avatar: false,
        paragraph: false,
      },
      centralValue: {
        loading: isLoading,
        active: true,
        avatar: false,
        paragraph: false,
        title: {
          style: {
            width: '100%',
            height: 11,
            borderRadius: 2,
            marginTop: 2,
            marginBottom: 1,
          },
        },
      },
    },
  };

  const centralValueSkeleton = (
    <div {...attrs.footerTick}>
      <Skeleton {...attrs.skeletons.centralValue} />
    </div>
  );

  return (
    <>
      {children}
      {isLoading ? (
        <div {...attrs.wrapper}>
          <div {...attrs.body.wrapper}>
            <div {...attrs.body.greyZone} />
          </div>
          <div {...attrs.footer}>
            {centralValueSkeleton}
            {centralValueSkeleton}
            {centralValueSkeleton}
            {centralValueSkeleton}
            {centralValueSkeleton}
            {centralValueSkeleton}
          </div>
        </div>
      ) : null}
    </>
  );
};
